import * as React from 'react';
import AppointmentErrorContainer from '../../../../components/AppointmentError/AppointmentErrorContainer.js';
import { appointmentErrors } from '../../../../utils/appointments.js';
import { useCancelAppointmentContext } from '../../context/context.js';
import '@swc/helpers';
import CancelAppointmentContainer from './CancelAppointmentContainer.js';
import CancelAppointmentRootWithMyAccountEnabled from './CancelAppointmentRootWithUserToken.js';

const CancelAppointmentRoot = ()=>{
    const { config: { appointmentId , token , bookAppointmentUrl  } ,  } = useCancelAppointmentContext();
    if (appointmentId) {
        return /*#__PURE__*/ React.createElement(CancelAppointmentRootWithMyAccountEnabled, {
            appointmentId: appointmentId
        });
    }
    if (token) {
        return /*#__PURE__*/ React.createElement(CancelAppointmentContainer, {
            token: token
        });
    }
    return /*#__PURE__*/ React.createElement(AppointmentErrorContainer, {
        status: appointmentErrors[0],
        bookAppointmentUrl: bookAppointmentUrl
    });
};

export { CancelAppointmentRoot as default };
//# sourceMappingURL=CancelAppointmentRoot.js.map
